var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { GridLayout } from "./GridLayout";
var GridContainer = /** @class */ (function (_super) {
    __extends(GridContainer, _super);
    function GridContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridContainer.prototype.componentDidMount = function () {
        this.emitSelectedItem(this.props.selectedIndex);
    };
    GridContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, gridItemRenderer = _a.gridItemRenderer;
        var props = {
            gridItemRenderer: gridItemRenderer,
            items: items,
            onClick: function (index) { return _this.onGridItemSelect(index); },
            selectedItemIndex: this.props.selectedIndex,
        };
        return React.createElement(GridLayout, __assign({}, props));
    };
    GridContainer.prototype.onGridItemSelect = function (index) {
        this.emitSelectedItem(index);
    };
    GridContainer.prototype.emitSelectedItem = function (index) {
        var onSelect = this.props.onSelect;
        if (onSelect) {
            onSelect(index);
        }
    };
    return GridContainer;
}(React.Component));
export { GridContainer };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/grid-layout/GridContainer.tsx
// module id = 227
// module chunks = 3